import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs, Button, Popconfirm, message, Card, Avatar, Typography, Row, Col } from "antd";
import dataService from "../../networks/api/service/dataService";
import colors from "../../assets/styles/colour";
import { ArrowLeftOutlined } from "@ant-design/icons";
const { TabPane } = Tabs;

const VehicleDetails = () => {
  const { state } = useLocation();
  const [vehicle, setVehicle] = useState(state?.vehicleData || {});
const [loading, setLoading] = useState(false);
const [tripHistory, setTripHistory] = useState([]);
  
const { Title, Text } = Typography;

    const navigate = useNavigate();


    useEffect(() => {
        const fetchVehicleDetails = async () => {
          const driverId = "";
          const vehicleId = vehicle.id;
          if (!state?.vehicleData?._id) return;
          setLoading(true);
          try {
            const res = await dataService.getTripHistory(state.vehicleData._id,driverId);
            console.log("Trip history response:", res.data);
      
            // Keep existing vehicle info and just add tripHistory
            if (res.data) {
              setTripHistory(res.data); // Assuming API returns just the trip history array
            }
          } catch (error) {
            message.error("Failed to fetch trip history");
          } finally {
            setLoading(false);
          }
        };
      
        fetchVehicleDetails();
      }, [state]);
      
  const handleEdit = () => {
    navigate("/login/TransportDetails", {
      state: { mode: "edit", vehicleData: vehicle },
    });
    message.info(`Edit clicked for: ${vehicle.makeAndModel}`);
  };

  const handleDelete = async () => {
    try {
      await dataService.deleteVehicle(vehicle._id);
      message.success("Vehicle deleted successfully");
      navigate(-1); // go back after deletion
    } catch (error) {
      console.error("Delete failed:", error);
      message.error("Failed to delete vehicle");
    }
  };

  if (!vehicle) {
    return <p>No vehicle data found.</p>;
  }

  return (
    <div style={{ padding: 20 }}>
    <Button
      icon={<ArrowLeftOutlined />}
      onClick={() => navigate(-1)}
      style={{ marginBottom: 20 }}
    >
      Back
    </Button>
    <h2>{vehicle?.makeAndModel || "Vehicle"} - Details</h2>
  
    <Tabs defaultActiveKey="1">
      {/* Overview Tab */}
      <TabPane tab="Overview" key="1">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <p><strong>Type:</strong> {vehicle.makeAndModel}</p>
            <p><strong>Reg No:</strong> {vehicle.registrationNum}</p>
            <p><strong>Status:</strong> {vehicle.isAssigned ? "Unavailable" : "Available"}</p>
          </Col>
        </Row>
  
        {tripHistory.length > 0 && tripHistory[0].driver ? (
          <Card
            title="Assigned Driver"
            bordered={true}
            style={{ marginTop: 16, borderRadius: 10, boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}
          >
            <Row gutter={[16, 16]} align="middle">
              <Col xs={24} sm={8} md={6} lg={4} xl={4} style={{ textAlign: "center" }}>
                <Avatar
                  size={64}
                  src={tripHistory[0].driver.image || "https://static.vecteezy.com/system/resources/previews/026/615/556/non_2x/driver-icon-isolated-on-white-background-vector.jpg"}
                />
              </Col>
              <Col xs={24} sm={16} md={18} lg={20} xl={20}>
                <Title level={5} style={{ marginBottom: 8 }}>
                  {tripHistory[0].driver.driverName}
                </Title>
                <Text>📞 {tripHistory[0].driver.driverPhoneNumber}</Text><br />
                <Text>📧 {tripHistory[0].driver.driverEmail}</Text><br />
                <Text>
                  Status:{" "}
                  <b style={{ color: tripHistory[0].driver.isAssigned ? "red" : "green" }}>
                    {tripHistory[0].driver.isAssigned ? "Assigned" : "Available"}
                  </b>
                </Text>
              </Col>
            </Row>
          </Card>
        ) : (
          <p>No assigned driver available.</p>
        )}
      </TabPane>
  
      {/* Insurance Tab */}
      <TabPane tab="Insurance" key="2">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <p><strong>Insurance:</strong> {vehicle.insuranceProvider}</p>
            <p><strong>Valid Till:</strong> {vehicle.lastValidityDate}</p>
          </Col>
        </Row>
      </TabPane>
  
      {/* Maintenance Tab */}
      <TabPane tab="Maintenance" key="3">
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <p>Maintenance info goes here...</p>
          </Col>
        </Row>
      </TabPane>
  
      {/* Documents Tab */}
      <TabPane tab="Documents" key="4">
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <p>Documents info goes here...</p>
          </Col>
        </Row>
      </TabPane>
  
      {/* History Tab */}
      <TabPane tab="History" key="5">
        {tripHistory.length > 0 ? (
          tripHistory.map((trip, index) => (
            <Row key={trip._id || index} gutter={[16, 16]} style={{ marginBottom: 16 }}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <div style={{ padding: 12, border: "1px solid #ccc", borderRadius: 8 }}>
                  <p><strong>Trip Type:</strong> {trip.tripType}</p>
                  <p><strong>Start:</strong> {new Date(trip.startDateTime).toLocaleString()}</p>
                  <p><strong>End:</strong> {new Date(trip.endDateTime).toLocaleString()}</p>
                  <p><strong>Start Point:</strong> {trip.startPoint}</p>
                  <p><strong>End Point:</strong> {trip.endPoint}</p>
                  <p><strong>Driver Name:</strong> {trip.driver?.driverName}</p>
                  <p><strong>Phone:</strong> {trip.driver?.driverPhoneNumber}</p>
                  <p><strong>Persons in Trip:</strong> {trip.personsInTrip}</p>
                  <p><strong>Distance Traveled:</strong> {trip.distanceTraveled} km</p>
                  <p><strong>Description:</strong> {trip.description}</p>
                </div>
              </Col>
            </Row>
          ))
        ) : (
          <p>No trip history available for this vehicle.</p>
        )}
      </TabPane>
    </Tabs>
  
    {/* Action Buttons */}
    <Row gutter={[16, 16]} justify="space-between" style={{ marginTop: 20 }}>
      <Col>
        <Button type="primary" onClick={handleEdit}>Edit</Button>
      </Col>
      <Col>
        <Popconfirm
          title="Are you sure to delete this vehicle?"
          onConfirm={handleDelete}
          okText="Yes"
          cancelText="No"
        >
          <Button danger>Delete</Button>
        </Popconfirm>
      </Col>
    </Row>
  </div>
  );
};

export default VehicleDetails;
